import styled from "styled-components";
import { FullHeightGrid } from "./FullHeightGrid";
export const XYGrid = styled(FullHeightGrid) `
  grid-template-rows: ${props => props.$template_rows};
  grid-template-columns: ${props => props.$template_columns};
`;
